import i18n from "../lang/i18n";

export default {
    state: {
        statuses: [
            {value: true, text: i18n.t('msg.yes')},
            {value: false, text: i18n.t('msg.no')}
        ]
    },
    actions: {
        loadTimeTypes() {
            return this.dispatch('sendRequest', { path: '/dict/plan/time-type', data: {}, method: 'get', formErrors: {} });
        },

        loadCurrencies() {
            return this.dispatch('sendRequest', { path: '/dict/finance/currency', data: {}, method: 'get', formErrors: {} });
        },
        loadGroupTypes() {
            return this.dispatch('sendRequest', { path: '/dict/finance/type', data: {}, method: 'get', formErrors: {} });
        }
    }
}